import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout } from '@/_containers';

export default function Loading() {
  return (
    <CardContainer>
      <FormLayout>
        <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
        <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
        <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
        <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
        <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
        <InputSkeleton className="col-span-12 sm:col-span-6 md:col-span-4" />
        <div className="col-span-12 grid grid-cols-12 gap-6">
          <InputSkeleton className="col-span-6" />
          <InputSkeleton className="col-span-6" />
        </div>
      </FormLayout>
    </CardContainer>
  );
}
